import React from "react";
import { Modal, Button } from "antd";

export default function SummarySerialsModal({
  visible,
  onClose,
  summarySerials,
}) {
  return (
    <Modal
      title="Resumen de seriales devueltos"
      open={visible}
      onOk={onClose}
      onCancel={onClose}
      footer={[
        <Button key="ok" type="primary" onClick={onClose}>
          OK
        </Button>,
      ]}
    >
      <ul>
        {summarySerials.map((r) => (
          <li key={r.productoId || r.productId}>
            {r.producto || r.product}: {r.cantidad || r.quantity} seriales devueltos
          </li>
        ))}
      </ul>
    </Modal>
  );
} 